import React, { useState } from 'react';

const StarRating = ({ rating, setRating, disabled = false, size = 'medium' }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleStarClick = (starValue) => {
    if (!disabled) {
      setRating(starValue);
    }
  };

  const handleStarHover = (starValue) => {
    if (!disabled) {
      setHoverRating(starValue);
    }
  };

  const handleStarLeave = () => {
    if (!disabled) {
      setHoverRating(0);
    }
  };

  const getStarSize = () => {
    switch (size) {
      case 'small':
        return '1.2rem';
      case 'large':
        return '2rem';
      default:
        return '1.5rem';
    }
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${
            star <= (hoverRating || rating) ? 'filled' : 'empty'
          } ${disabled ? 'disabled' : ''}`}
          onClick={() => handleStarClick(star)}
          onMouseEnter={() => handleStarHover(star)}
          onMouseLeave={handleStarLeave}
          style={{ fontSize: getStarSize() }}
        >
          ★
        </span>
      ))}
      
      <style jsx>{`
        .star-rating {
          display: flex;
          gap: 4px;
          align-items: center;
        }
        
        .star {
          cursor: pointer;
          transition: all 0.2s ease;
          user-select: none;
          color: transparent;
          -webkit-text-stroke: 1px #ccc;
          text-stroke: 1px #ccc;
        }
        
        .star:hover {
          transform: scale(1.1);
          -webkit-text-stroke: 1px #666;
          text-stroke: 1px #666;
        }
        
        .star.filled {
          color: #000;
          -webkit-text-stroke: 1px #000;
          text-stroke: 1px #000;
        }
        
        .star.empty {
          color: transparent;
          -webkit-text-stroke: 1px #ccc;
          text-stroke: 1px #ccc;
        }
        
        .star.disabled {
          cursor: default;
          opacity: 0.7;
        }
        
        .star.disabled:hover {
          transform: none;
          -webkit-text-stroke: 1px #ccc;
          text-stroke: 1px #ccc;
        }
      `}</style>
    </div>
  );
};

export default StarRating; 